import { useAsyncData } from '#imports'
import { computed } from 'vue'

import { mapToReviews } from '@backmarket/nuxt-layer-cms/Reviews.utils'
import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import { getMatchingReviewId } from '~/scopes/product-core/components/presentationals/GalleryNew/components/Review/Review.utils'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'
import { getOptionalEndpointTimeoutOptions } from '~/scopes/product-core/composables/useFetch/utils/getOptionalEndpointTimeoutOptions'

export function useFetchReviewInGalleryNew() {
  const experiments = useExperiments()
  const marketplace = useMarketplace()
  const $httpFetch = useHttpFetch()
  const { data: productResponse } = useFetchProduct()

  const isFeatureFlagEnabled =
    experiments['experiment.ppReviewsInCarousel'] === 'withReviewsInCarousel'

  const reviewIds = computed(() =>
    productResponse.value?.tracking.categoryId
      ? getMatchingReviewId({
          countryCode: marketplace.market.countryCode,
          categoryId: productResponse.value.tracking.categoryId,
          productBrand: productResponse.value.brand,
          productModel: productResponse.value.model ?? '',
        })
      : null,
  )

  return useAsyncData(
    `pp-preview-in-gallery-new-${reviewIds.value}`,
    async () => {
      if (!isFeatureFlagEnabled || !reviewIds.value) {
        return undefined
      }

      return await $httpFetch('/reviews/v1/products/reviews', {
        query: { public_id__in: reviewIds.value },
      })
    },
    {
      transform: (data) => {
        if (!data) {
          return undefined
        }

        const reviews = mapToReviews(data.results)

        return reviews[0] ? { ...reviews[0], count: data.count } : undefined
      },
      dedupe: 'defer',
      ...getOptionalEndpointTimeoutOptions(),
    },
  )
}
